import { format, fromUnixTime } from 'date-fns';
import { css } from '../../../styled-system/css';

type Period = {
  /**
   * 開始年月(UnixTimestamp: 秒)
   *
   * 所属していれば必ず存在する
   */
  start: number;
  /**
   * 終了年月(UnixTimestamp: 秒)
   *
   * 在籍中であれば存在しない
   */
  end?: number;
};

type EnrollmentPeriodProps = {
  period: Period;
  /**
   * 説明文
   *
   * 在籍中であれば存在しない
   */
  explanatoryText?: string;
  attachedItems?: Array<Omit<EnrollmentPeriodProps, 'attachedItems'>>;
};

/**
 * 在籍期間と内容を表示する
 */
export function EnrollmentDetail({ period, explanatoryText, attachedItems = [] }: EnrollmentPeriodProps) {
  return (
    <>
      <EnrollmentPeriod
        className={css({ textStyle: 'body.m.default', color: '{colors.text.main}' })}
        period={period}
        explanatoryText={explanatoryText}
      />
      {attachedItems.map(({ period, explanatoryText }, index) => (
        <EnrollmentPeriod
          key={index}
          className={css({
            textStyle: 'body.s.defalut',
            color: '{colors.text.sub}',
            marginLeft: '{spacing.16}',
          })}
          period={period}
          explanatoryText={explanatoryText}
        />
      ))}
    </>
  );
}

/**
 * 在籍期間へフォーマットする
 *
 * 例: 2024年4月 - 2025年3月, 2024年4月 -
 */
function formatPeriod(period: Period) {
  const { start, end } = period;
  const startDate = format(fromUnixTime(start), 'yyyy年M月');
  if (end) {
    const endDate = format(fromUnixTime(end), 'yyyy年M月');
    return `${startDate} - ${endDate}`;
  }
  return `${startDate} - `;
}

function EnrollmentPeriod({
  period,
  explanatoryText,
  className,
}: {
  period: Period;
  explanatoryText?: string;
  className?: string;
}) {
  return (
    <p className={className}>
      <span>{formatPeriod(period)}</span>
      <span>{explanatoryText}</span>
    </p>
  );
}
